var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "page-header" }, [
    _c("div", { class: ["page-header-wide", _vm.layout] }, [
      _c(
        "div",
        { staticClass: "breadcrumb" },
        [
          _c(
            "a-breadcrumb",
            _vm._l(_vm.breadcrumb, function(item, index) {
              return _c("a-breadcrumb-item", { key: item.path }, [
                index === 0
                  ? _c("span", [
                      _c("a", { attrs: { href: "#/dashboard/workplace" } }, [
                        _vm._v(_vm._s(item.name))
                      ])
                    ])
                  : _c("span", [_vm._v(_vm._s(item.name))])
              ])
            }),
            1
          )
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6740ec88", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6740ec88","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/page/PageHeader.vue
// module id = null
// module chunks = 